<sk-date-picker-input [minDate]="minDate" [maxDate]="maxDate" [options]="options" (dateSelected)="emitSelectedValue($event)"></sk-date-picker-input>